import { Link } from "@quintype/components";
import { get } from "lodash";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import AccLoginBtn from "../../../../../atoms/acc-login";
import NewsletterBtn from "../../../../../atoms/newsletter-btn";
import Close from "../../../../../atoms/other-icons/Close";
import Hamburger from "../../../../../atoms/other-icons/Hamburger";
import PVLogo from "../../../../../atoms/other-icons/PVLogo";
import Search from "../../../../../atoms/other-icons/Search";
import { OPEN_HAMBURGER_MENU } from "../../../../../store/actions";
import "./nav-bar.m.css";

const Navbar = ({ signinHandler, onAccountHandler, isSearchOpen, toggleSearch }) => {
  const getState = useSelector((state) => state);
  const isHamburgerMenuOpen = get(getState, ["isHamburgerMenuOpen"], false);
  const dispatch = useDispatch();
  const onHamburgerClick = () => {
    dispatch({
      type: OPEN_HAMBURGER_MENU,
      isHamburgerMenuOpen: !isHamburgerMenuOpen
    });
  };

  return (
    <nav styleName="nav-bar-wrapper">
      <Link href="/">
        <PVLogo />
      </Link>
      <div styleName="nav-bar-right">
        {isHamburgerMenuOpen && toggleSearch && (
          <div onClick={toggleSearch} styleName="search-icon">
            <Search color="black" />
          </div>
        )}
        <AccLoginBtn signinHandler={signinHandler} onAccountHandler={onAccountHandler} />
        <NewsletterBtn />
        <div onClick={onHamburgerClick} styleName="hamburger-toggle">
          {isHamburgerMenuOpen ? (
            <Close />
          ) : (
            <Hamburger />
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
